import React, {useEffect, useState} from "react";
import axios from "axios";
import {
    CircularProgress, Grid, IconButton, InputBase, Paper, Table, TableBody, TableCell, tableCellClasses,
    TableContainer, TableHead, TableRow,
} from "@mui/material";
import {styled} from '@mui/material/styles';
import EditIcon from '@mui/icons-material/Edit';
import Box from "@mui/material/Box";
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import {Link} from "react-router-dom";
import Dialog from "@mui/material/Dialog";

const Pishfactorlist = ({change, setchange, btnedit, setcustomername, setcustomertel, setkey}) => {
    const [pishfactorlist, setPishfactorlist] = useState([])
    const [loading, setLoading] = React.useState(true);
    const [txt_search, setTxt_search] = React.useState("");
    useEffect(() => {
        const data = {
            search: txt_search,
            token: localStorage.getItem("token"),
        };
        axios.post("https://app.zhivay.com/api/get_factorlist.php", data, )
            .then(response => {
                setLoading(false);
                if (response.status ===200){
                    if (response.data.error === false){
                        setPishfactorlist(response.data.data);
                    }
                }
            })
            .catch(error => {
                setLoading(false);
                console.log(error)
            });
    }, [change])

    const StyledTableCell = styled(TableCell)(({theme}) => ({
        [`&.${tableCellClasses.head}`]: {
            backgroundColor: theme.palette.common.black,
            color: theme.palette.common.white,
        },
        [`&.${tableCellClasses.body}`]: {
            fontSize: 14,
        },
    }));

    const StyledTableRow = styled(TableRow)(({theme}) => ({
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
        '&:last-child td, &:last-child th': {
            border: 0,
        },
    }));
    const hendel_edit_click = (customername, customertel, key) => {
        setkey(key);
        setchange(true);
        setcustomername(customername);
        setcustomertel(customertel);
        btnedit(true);
    }
    const handle_search_change = (event) => {
        setTxt_search(event.target.value);
    }

    return (
        <Box>
            <div style={{margin: '10px'}}>
                        <Paper
                            dir="rtl"
                            component="form"
                            sx={{p: '2px 4px', display: 'flex', alignItems: 'center', width: '99%', marginBottom: 2}}>
                            <InputBase
                                sx={{ml: 1, flex: 1}}
                                placeholder="جست و جو"
                                onChange={handle_search_change}
                                value={txt_search}
                                onKeyPress={(e) => {
                                    if (e.key === 'Enter') {
                                        e.preventDefault();
                                        setchange(true);
                                        setLoading(true);
                                    }

                                }}
                                type={"text"}
                                inputProps={{'aria-label': 'جست و جو'}}
                            />
                            <IconButton
                                type="button"
                                sx={{p: '10px'}}
                                onClick={() => {
                                    setchange(true);
                                    setLoading(true);
                                }
                                }
                                aria-label="search"
                            >
                                <SearchIcon/>
                            </IconButton>
                            {txt_search !== "" ?
                                <IconButton
                                    type="button"
                                    sx={{p: '10px'}}
                                    onClick={() => {
                                        setTxt_search("");
                                        setchange(true);
                                        setLoading(true);
                                    }
                                    }
                                    aria-label="search"
                                >
                                    <ClearIcon/>
                                </IconButton>
                                : ''}
                        </Paper>
                        <Grid
                            container
                            sx={{direction: "rtl"}}
                            direction="row"
                            justifyContent="center"
                            alignItems="center">
                            <TableContainer component={Paper}>
                                <Table sx={{minWidth: 250, maxHeight: '80%', overflowY: 'auto',}}
                                       className='tbl-pishfactor'>
                                    <TableHead>
                                        <TableRow>
                                            <StyledTableCell></StyledTableCell>
                                            <StyledTableCell align="right">شماره فاکتور</StyledTableCell>
                                            <StyledTableCell align="right">نام مشتری</StyledTableCell>
                                            <StyledTableCell align="right">مانده حساب</StyledTableCell>
                                            <StyledTableCell align="right">کاربر</StyledTableCell>
                                            <StyledTableCell align="right">تاریخ</StyledTableCell>
                                            <StyledTableCell>عملیات</StyledTableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {pishfactorlist.map(product1 => (
                                            <StyledTableRow
                                                component={Link} to={`/factors/${product1.key}/`}
                                                onClick={() => hendel_edit_click(product1.customername, product1.customertel, product1.key)}
                                                key={product1.fr_id}
                                                sx={{'&:last-child td, &:last-child th': {border: 0}}}>

                                                {product1.factortype === "prefactor" ?
                                                    <StyledTableCell
                                                        sx={{backgroundColor: "#e8d130", textAlign: "right", width: 2}}
                                                        align="right">
                                                        <p style={{
                                                            fontSize: "10px",
                                                            writingMode: "vertical-rl",
                                                            margin: 0
                                                        }}>پیش فاکتور</p>
                                                    </StyledTableCell>
                                                    :
                                                    <StyledTableCell
                                                        sx={{backgroundColor: "#086b05", textAlign: "right", width: 2}}
                                                        align="right">
                                                        <p style={{
                                                            fontSize: "10px",
                                                            writingMode: "vertical-rl",
                                                            color: "#FFFFFF",
                                                            margin: 0
                                                        }}>فاکتور</p>
                                                    </StyledTableCell>
                                                }
                                                <StyledTableCell align="right">{product1.factornumber}</StyledTableCell>
                                                <StyledTableCell sx={{direction: "ltr"}}
                                                                 align="right">{product1.customername}</StyledTableCell>
                                                <StyledTableCell sx={{direction: "ltr"}}
                                                                 align="right">{product1.balance}</StyledTableCell>
                                                <StyledTableCell align="right">{product1.ownername}</StyledTableCell>
                                                <StyledTableCell align="right">{product1.date}</StyledTableCell>
                                                <StyledTableCell>
                                                    <IconButton
                                                        onClick={() => hendel_edit_click(product1.customername, product1.customertel, product1.key)}
                                                        aria-label="view"><EditIcon color={"primary"}/></IconButton>
                                                </StyledTableCell>
                                            </StyledTableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>
            </div>
            <Dialog
                open={loading}
                scroll="paper">
                <CircularProgress sx={{margin:2}} />
            </Dialog>

        </Box>
    )
}
export default Pishfactorlist